import { IPriceModel } from '@sharedComponents/Prices';

export const ORDER_AS_LAST_TIME_LOADER_SIZE = 34.5;

export const ORDER_AS_LAST_TIME_PRICE_SIZE_STRING = '0.9rem';

export const ORDER_AS_LAST_TIME_PRICE: IPriceModel = {
  bold: true,
  priceSize: ORDER_AS_LAST_TIME_PRICE_SIZE_STRING,
  currencySize: ORDER_AS_LAST_TIME_PRICE_SIZE_STRING,
};

export const ORDER_CHECK_EXISTS_RETRIES = 10;
export const ORDER_CHECK_EXISTS_TIMEOUT = 1000;
export const ORDER_CHECK_EXISTS_RETRY_FACTOR = 1;
